<template>
  <div class="rect"
    :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SeatRect',
  props: [
    'w',
    'h',
    'x',
    'y'
  ],
  computed: {
    style () {
      return {
        width: `${this.w}px`,
        height: `${this.h}px`,
        left: `${this.x}px`,
        top: `${this.y}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rect {
  position: absolute;
}
</style>
